import { createContext, useState } from 'react'

const ShapeContext = createContext();



const Shapefile = (props) => {
    let shxData = undefined;
    const [shpData, setShpData] = useState(null);
    const [dbfData, setDbfData] = useState(null);

    function importShp(shpBinary, shxBinary, dbfBinary) {
        shxData = ShxReader(shxBinary);
        console.log(shxData);
        const shpData1 = ShpReader(shpBinary, shxData);
        setShpData(shpData1);
        console.log("shpData ", shpData);
        const dbfData1 = DbfReader(dbfBinary);
        setDbfData(dbfData1);
        console.log(dbfData);
        //ShpReader(shpBinary);
        /*const shxData = createShxObject(100);
        console.log("shxData 1 = ", shxData);
        const poli1 = createShxPoligonIndex(1, 10);
        shxData.polygonsIndex[0] = poli1;
        console.log("shxData 2 = ", shxData);
        const poli2 = createShxPoligonIndex(2, 20);
        shxData.polygonsIndex[1] = poli2;
        console.log("shxData 3 = ", shxData);*/
        
    }

    return (
        <ShapeContext.Provider value={{ importShp, shpData, dbfData }}>
            {props.children}
        </ShapeContext.Provider>
      )
}

function createShpObject(fileLenght) {
    return {
        fileLenght,
        boxXmin: null,
        boxYmin: null,
        boxXmax: null,
        boxYmax: null,
        record: [null]
    }
}

function createShpRecord() {
    return {
        recordNumber: null,
        contentLength: null,
        shapeType: null,
        boxXmin: null,
        boxYmin: null,
        boxXmax: null,
        boxYmax: null,
        numParts: null,
        numPoints: null,
        parts: [null],
        points: [null]
    }
}

function createPoint(x, y) {
    return {
        x,
        y
    }
}

function createShxObject(contentLength, polyCount) {
    return {
        contentLength,
        polyCount,
        polygonsIndex: [null]
    }
}

function createShxPoligonIndex(index, length) {
    return {
        index: index,
        length: length
    }
}

function createDbfObject (numOfRecords, numOfBytesHeader, numOfBytesRecord, qtdOfRecords) {
    return {
        numOfRecords,
        numOfBytesHeader,
        numOfBytesRecord,
        qtdOfRecords,
        limites: [null],
        records: [null]
    }
}
function createLimites (min, max) {
    return {
        limiteMax: max,
        limiteMin: min
    }
}

function createDbfRecord(index, nomeColuna, fieldLength, fieldDecimalCount) {
    return {
        index,
        nomeColuna,
        fieldLength,
        fieldDecimalCount,
        data: [null]
    }
}

function ShpReader(array, shxData) {
    var dataview = new DataView(array, 0, array.length);
    const fileLenght = dataview.getInt32(24, false);
    const shpData = createShpObject(fileLenght);
    shpData.boxXmin = dataview.getFloat64(36, true);
    shpData.boxYmin = dataview.getFloat64(44, true);
    shpData.boxXmax = dataview.getFloat64(52, true);
    shpData.boxYmax = dataview.getFloat64(60, true);
    /*ShapeFile Header
    console.log("dataview1 = ", dataview1);
    console.log("FileCode = ", dataview1.getInt32(0, false));
    console.log("FileLenght = ", dataview1.getInt32(24, false));
    console.log("Version = ", dataview1.getInt32(28, true));
    console.log("ShapeType = ", dataview1.getInt32(32, true));
    console.log("BBoxXmin = ", dataview1.getFloat64(36, true));
    console.log("BBoxYmin = ", dataview1.getFloat64(44, true));
    console.log("BBoxXmax = ", dataview1.getFloat64(52, true));
    console.log("BBoxYmax = ", dataview1.getFloat64(60, true));*/
    //Começa o loop de poligonos
    for (let i = 0; i < shxData.polyCount; i++) {
        const shpRecord = createShpRecord();
        const recordIndex = shxData.polygonsIndex[i].index * 2;
        shpRecord.recordNumber = dataview.getInt32(recordIndex, false);
        shpRecord.contentLength = dataview.getInt32(recordIndex + 4, false);
        shpRecord.shapeType = dataview.getInt32(recordIndex + 8, true);
        shpRecord.boxXmin = dataview.getFloat64(recordIndex + 12, true);
        shpRecord.boxYmin = dataview.getFloat64(recordIndex + 20, true);
        shpRecord.boxXmax = dataview.getFloat64(recordIndex + 28, true);
        shpRecord.boxYmax = dataview.getFloat64(recordIndex + 36, true);
        shpRecord.numParts = dataview.getInt32(recordIndex + 44, true);
        shpRecord.numPoints = dataview.getInt32(recordIndex + 48, true);
        for (let j=0; j < shpRecord.numParts; j++) {
            shpRecord.parts[j] = dataview.getInt32(recordIndex + 52 + j * 4, true);
        }
        for (let j=0; j < shpRecord.numPoints; j++) {
            const x = dataview.getFloat64(recordIndex + 52 + 4 * shpRecord.numParts + j * 16, true);
            const y = dataview.getFloat64(recordIndex + 60 + 4 * shpRecord.numParts + j * 16, true);
            shpRecord.points[j] = createPoint(x, y);
        }
        shpData.record[i] = shpRecord;
    }
    //Record header
    console.log("array: ", array, "dataview: ", dataview);

    return shpData;
}

function ShxReader(array) {    
    var dataview1 = new DataView(array, 0, array.length);
    let contentLength = dataview1.getInt32(24, false);
    let polyCount = (contentLength - 50) / 4;  
    const shxData = createShxObject(contentLength, polyCount);

    console.log("shxData ", shxData, " com ", polyCount, " poligonos");

    for (let i = 0; i < polyCount; i++) {
        let offset = dataview1.getInt32(100 + i * 8, false);
        let length = dataview1.getInt32(104 + i * 8, false);
        shxData.polygonsIndex[i] = createShxPoligonIndex(offset, length)
    }
    return shxData;
}

function DbfReader(array) {
    var byteArray = new Uint8Array(array);
    var dataview1 = new DataView(array, 0, array.length);
    let numberOfRecords = dataview1.getInt32(4, true);
    let numberOfBytesHeader = dataview1.getInt16(8, true);
    let numberOfBytesRecord = dataview1.getInt16(10, true);
    let qtdOfRecords = (numberOfBytesHeader - 1 - 32) / 32;
    const dbfData = createDbfObject(numberOfRecords, numberOfBytesHeader, numberOfBytesRecord, qtdOfRecords);
    for (let i = 0; i < qtdOfRecords; i++) {
        //createRecord
        let nomeArray = new Uint8Array([
            byteArray[32 + i * 32],
            byteArray[33 + i * 32],
            byteArray[34 + i * 32],
            byteArray[35 + i * 32],
            byteArray[36 + i * 32],
            byteArray[37 + i * 32],
            byteArray[38 + i * 32],
            byteArray[39 + i * 32],
            byteArray[40 + i * 32],
            byteArray[41 + i * 32],
            byteArray[42 + i * 32]
        ]);
        let decoder = new TextDecoder("utf-8");
        let nome = decoder.decode(nomeArray);
        let fieldLength = dataview1.getInt8(32 + 16 + i * 32);
        let fieldDecimalCount = dataview1.getInt8(32 + 17 + i * 32);
        dbfData.records[i] = createDbfRecord(i, nome, fieldLength, fieldDecimalCount);
        dbfData.limites[i] = createLimites(100_000, 0);
    }
    // Agora examina as linhas
    let indexAux = numberOfBytesHeader; //position of first data record
    for (let i = 0; i < numberOfRecords; i++)
    {
        indexAux++; //mais um espaço inicial "deletion flag"
        for (let j = 0; j < qtdOfRecords; j++)
        {
            let dadosArray = new Uint8Array(dbfData.records[j].fieldLength);
            //console.log("length do field = ", dbfData.records[j].fieldLenght);
            for (let k = 0; k < dbfData.records[j].fieldLength; k++)
            {
                dadosArray[k] = byteArray[indexAux];
                indexAux++;
            }
            let decoder = new TextDecoder("utf-8");
            let dado = decoder.decode(dadosArray);
            const valor = parseFloat(dado);
            //console.log("valor = ", valor);
            dbfData.records[j].data[i] = valor;
            if (valor < dbfData.limites[j].limiteMin)
                dbfData.limites[j].limiteMin = valor;
            if (valor > dbfData.limites[j].limiteMax)
                dbfData.limites[j].limiteMax = valor;
            /*byte[] arrayParcial = new byte[fieldLength[j]];
            Array.Copy(dadosdbf, indexAux, arrayParcial, 0, fieldLength[j]);
            indexAux += fieldLength[j];
            string recordFieldASCII = System.Text.Encoding.Default.GetString(arrayParcial);
            //Debug.Log($"Record[{i}]: Coluna[{j}] = {recordFieldASCII}");
            if (j == indexPrescricao)
            {
                recordFieldASCII = recordFieldASCII.Replace(',', '.');
                recordFieldASCII = recordFieldASCII.Replace('*', '0');
                float prescricao = 0f;
                try
                {
                    prescricao = float.Parse(recordFieldASCII);
                    if (prescricao > maxPrescript) maxPrescript = prescricao;
                    if ((prescricao < minPrescription) && (prescricao > 0)) minPrescription = prescricao;
                }
                catch { }
                prescription.Add(prescricao);
            }*/
        }
    }
    console.log("dbfData = ", dbfData);
    return dbfData;
}
export { ShapeContext, Shapefile }
